// extracted by mini-css-extract-plugin
module.exports = {"row":"HomePageCustomiser_row__2fiIB","col":"HomePageCustomiser_col__11O3c","card":"HomePageCustomiser_card__1g10h"};